// extracted by mini-css-extract-plugin
export var box = "_1k-2";
export var checkboxControl = "_1k-0";
export var checkboxRow = "_1k-a";
export var checked = "_1k-3";
export var descriptionSpacer = "_1k-c";
export var disabled = "_1k-4";
export var icon = "_1k-8";
export var input = "_1k-1";
export var labelSpacer = "_1k-b";
export var large = "_1k-7";
export var medium = "_1k-6";
export var small = "_1k-5";
export var text = "_1k-9";